<template>
  <div>
    <table class="tw-w-full">
      <tbody>
        <tr>
          <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
            Subtotal
          </td>
          <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
            ${{basketStore.basket ? basketStore.basket.subtotal.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
          </td>
        </tr>
        
        <template v-if="basketStore.basket?.discounts != null && basketStore.basket?.discounts.length > 0">
          <tr>
            <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
              Discounts
            </td>
            <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
              
            </td>
          </tr>

          <BagDiscount
            v-for="(discount, index) in basketStore.basket?.discounts"
            :key="'discount-'+(discount as Discount).couponcode"
            @emit-removeDiscount="clickedRemoveDiscount"
            :discount="discount">
          </BagDiscount>
        </template>

        <tr v-if="basketStore.basket && basketStore.basket.tip">
          <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
            Tip
          </td>
          <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
            ${{basketStore.basket && basketStore.basket.tip ? basketStore.basket.tip.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
          </td>
        </tr>

        <tr>
          <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
            Estimated Tax
          </td>
          <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
            ${{basketStore.basket && basketStore.basket.salestax ?basketStore.basket.salestax.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
          </td>
        </tr>

        <tr v-if="basketStore.basket && basketStore.basket.customerhandoffcharge">
          <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
            Delivery Fee
          </td>
          <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
            ${{basketStore.basket && basketStore.basket.customerhandoffcharge ? basketStore.basket.customerhandoffcharge.toLocaleString("en-US", {minimumFractionDigits: 2}) : '0.00'}}
          </td>
        </tr>

        <tr 
          v-for="(fee, index) in basketStore.basket && basketStore.basket.fees"
          :key="'fee-'+index"
        >
          <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
            {{fee.description}}
          </td>
          <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
            ${{fee.amount.toLocaleString("en-US", {minimumFractionDigits: 2})}}
          </td>
        </tr>

        <tr>
          <td class="tw-text-xl tw-uppercase tw-border-b tw-border-gray-300 tw-py-4 tw-pr-4">
            Total
          </td>
          <td class="tw-text-xl tw-text-right tw-border-b tw-border-gray-300 tw-py-4 tw-pl-4">
            ${{basketStore.basket && basketStore.basket.total ? parseFloat(basketStore.basket.total.toFixed(2)).toLocaleString() : '0.00'}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { DateTime } from "luxon";
import { storeToRefs } from 'pinia';

// Data
import { useBasketStore } from "../../stores/basket";
import { useUserStore } from '../../stores/user';
import type DerivedDiscountInterface from '../../types/DerivedDiscount';
import type Discount from '../../types/Discount';

const basketStore = useBasketStore();
const { basket } = storeToRefs(basketStore)
const userStore = useUserStore();
import BagDiscount from './_BagDiscount.vue';
import TwButton from '../../components/TwButton.vue';

const emit = defineEmits(['emitRemoveDiscount', 'emitRemoveDiscount'])

const processingRemove = ref(false);

const hideDiscounts = ref(false);

const clickedRemoveDiscount = (discount: Discount) => {
  processingRemove.value = true
  emit('emitRemoveDiscount', discount)
}

</script>